/*!
 * RedStar24 – custom-megamenu guard (Portal aktiv)
 * Wenn unser Portal läuft, macht dieses Skript nichts.
 */
(function(){
  'use strict';
  if (window.__RS_PANE_ON__ || document.body.classList.contains('rs-pane-on')) {
    return;
  }
  /* Optional: Touch-/Fallback-Logik kann hier bleiben, läuft nur wenn Portal aus ist. */
})();
